import { render, staticRenderFns } from "./FormFieldCollection.vue?vue&type=template&id=ef79ed12&"
import script from "./FormFieldCollection.vue?vue&type=script&lang=js&"
export * from "./FormFieldCollection.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldCollection.vue?vue&type=style&index=0&id=ef79ed12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports